



































































import { Component, Vue } from "vue-property-decorator";
import { Carousel, Slide } from "vue-carousel";
import { mapGetters } from "vuex";
import { IBannerCoupons } from "@/i/home.state.ts";
import { discountSize } from "@/services/discountSize.ts";
import { openCouponPopup } from "@/services/openCouponPopup.ts";
import { addGoal, EGoal } from "@/services/addYGoal.ts";

@Component({
  components: {
    Carousel,
    Slide
  },
  methods: {
    discountSize
  },
  computed: {
    ...mapGetters("home", ["getBannerImg"])
  }
})
export default class Banner extends Vue {
  imgArr: string[] = ["/img/img/banner_img.jpg", "/img/img/banner_img.jpg"];
  getBannerImg: IBannerCoupons;
  notShow: boolean = false;

  async handleClick(coupon) {
    await addGoal(EGoal.offer_click);
    openCouponPopup(coupon);
  }
}
